import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Resolve an image reference to a displayable URL.
// - absolute http(s) → as-is
// - /api/files/... (uploaded to object storage) → prefix backend URL
// - /images/... (public folder) → as-is
export function resolveImg(src) {
  if (!src) return "/images/insights.png";
  if (/^https?:\/\//.test(src)) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
}
